import {CreditOptions} from '../../../model/eligibility-check/credit-options.model';
import {SharedEligibilityCheckForm} from '../eligibility-check-form/eligibility-check-form.component';
import {Injectable} from '@angular/core';

export interface CategorizedCreditOptions {
    defaultOptions: CreditOptions;
    maximizedLoanAmountOptions: CreditOptions;
}

@Injectable()
export class CreditOptionsCategorizer {
    public categorize(creditOptions: CreditOptions, eligibilityCheckForm: SharedEligibilityCheckForm): CategorizedCreditOptions {
        const defaultOptions = creditOptions
            .filter((option) => option.amount <= eligibilityCheckForm.loanAmount)
            .sort((optionOne, optionTwo) => (optionOne.tenure - optionTwo.tenure));

        const maximizedLoanAmountOptions = creditOptions
            .filter((option) => option.amount > eligibilityCheckForm.loanAmount)
            .sort((optionOne, optionTwo) => (optionTwo.amount - optionOne.amount));

        return {defaultOptions, maximizedLoanAmountOptions};
    }
}
